"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var OauthApi = exports.default = /*#__PURE__*/function () {
  function OauthApi() {
    (0, _classCallCheck2.default)(this, OauthApi);
  }
  return (0, _createClass2.default)(OauthApi, null, [{
    key: "setup",
    value: function setup(givenConfig, connector) {
      OauthApi.config = givenConfig;
      OauthApi.xhrConnector = connector;
    }
  }, {
    key: "mustBeSettedUp",
    value: function mustBeSettedUp() {
      if (!OauthApi.config) {
        throw Error("OAuth config is missing!");
      }
      if (!OauthApi.xhrConnector) {
        throw Error("XHR handler is missing!");
      }
    }
  }, {
    key: "refreshIdToken",
    value: function refreshIdToken(refreshToken) {
      OauthApi.mustBeSettedUp();
      var body = new FormData();
      body.append('grant_type', 'refresh_token');
      body.append('redirect_uri', window.location.href);
      body.append('refresh_token', refreshToken);
      body.append('client_id', OauthApi.config.clientId);
      var promise = OauthApi.xhrConnector.post(OauthApi.config.refereshUrl, body);
      return promise;
    }
  }, {
    key: "getRedirectUriWithoutQParams",
    value: function getRedirectUriWithoutQParams() {
      return window.location.href.split('?')[0];
    }
  }, {
    key: "authorizationCodeExchange",
    value: function authorizationCodeExchange(code, codeVerifier) {
      OauthApi.mustBeSettedUp();
      var body = new FormData();
      body.append('grant_type', 'authorization_code');
      body.append('redirect_uri', OauthApi.getRedirectUriWithoutQParams());
      body.append('code', code);
      body.append('code_verifier', codeVerifier);
      body.append('client_id', OauthApi.config.clientId);
      var promise = OauthApi.xhrConnector.post(OauthApi.config.authorizationUrl, body);
      return promise;
    }
  }]);
}();
(0, _defineProperty2.default)(OauthApi, "config", void 0);
(0, _defineProperty2.default)(OauthApi, "xhrConnector", void 0);